<template>
    <div id="lanecarForm">
        <vxe-modal v-model="vis" title="Shipper From" width="100%" height="100%">

                <a-row type="flex">
                    <a-form :form="form">
                        <a-col :span="9">
                            <a-row type="flex" justify="start" align="middle">
                                <a-col class="titleNom">1</a-col>
                                <a-col class="titleFromName ml4" :span="20">From / Shipper</a-col>
                            </a-row>
                            <a-row class="fromRce mt">
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="contact Full Name">
                                        <a-input size="small" v-decorator="['pickupContact', { rules: [{ required: true, message: 'Required&&&contact Full Name' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom">
                                        <a-row type="flex" justify="space-between">
                                            <a-col class="laneFromTilte">Company Name</a-col>
                                            <a-col>
                                                <a-row type="flex" justify="start">
                                                    <a-checkbox size="small" style="color: #000;" @change="ResidentialAdrsChange">Residential Address</a-checkbox>
                                                </a-row>
                                            </a-col>
                                        </a-row>
                                        <a-input :disabled="isFromResident" size="small" v-decorator="['pickupName']" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row type="flex" justify="space-between">
                                    <a-col :span="11">
                                        <a-form-item class="genericFrom laneFrom" label="Origin">
                                            <a-input size="small" :placeholder="$t('publicLang.PleaseSelect')" v-decorator="['pickupCountry',{ rules: [{ required: true, message: 'Required&&&Origin' }] }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="11">
                                        <a-form-item class="genericFrom laneFrom" label="City">
                                            <a-input size="small" v-decorator="['pickupCity', { rules: [{ required: true, message: 'Required&&&City' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row  type="flex" justify="space-between">
                                    <a-col :span="7">
                                        <a-form-item class="genericFrom laneFrom" label="Postcode">
                                            <a-input size="small" v-decorator="['pickupPostalCode']" :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="7">
                                        <a-form-item class="genericFrom laneFrom" label="Suburb">
                                            <a-input size="small" v-decorator="['pickupSuburb']" :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="7">
                                        <a-form-item class="genericFrom laneFrom" label="State">
                                            <a-input size="small" :placeholder="$t('publicLang.PleaseSelect')" v-decorator="['pickupProvince']"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="Mobile (Preferred)/Landine">
                                        <a-row type="flex" justify="start">
                                            <a-col :span="6"><a-input size="small" :placeholder="$t('publicLang.PleaseSelect')" v-decorator="['pickupMCountryCode',{ rules: [{ required: true, message: 'Required&&&Mobile (Preferred)/Landine' }] }]" /></a-col>
                                            <a-col :span="10" class="ml4"><a-input size="small" v-decorator="['pickupPhone']" :placeholder="$t('publicLang.PleaseEnter')"/></a-col>
                                        </a-row>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="Email">
                                        <a-input size="small" v-decorator="['pickupEmail',{ rules: [{ required: true, message: 'From email is invalid format&&&Email' },{type: 'email',message: 'The input is not valid E-mail!'},]}]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="Address">
                                        <a-input size="small" v-decorator="['pickupAddress1', { rules: [{ required: true, message: 'Required&&&Address' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom">
                                        <a-input class="mt" size="small" v-decorator="['pickupAddress2', { rules: [{ required: true, message: 'Required&&&Address' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom">
                                        <a-input class="mt" size="small" v-decorator="['pickupAddress3', { rules: [{ required: true, message: 'Required&&&Address' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                            </a-row>
                        </a-col>
                        <a-col :span="9">
                            <a-row type="flex" justify="start" align="middle">
                                <a-col class="titleNom">2</a-col>
                                <a-col class="titleFromName ml4" :span="20">To Receiver</a-col>
                            </a-row>
                            <a-row class="fromRce mt">
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="Contact Full Name">
                                        <a-input size="small" v-decorator="['deliveryContact', { rules: [{ required: true, message: 'Required&&&Contact Full Name' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom">
                                        <a-row type="flex" justify="space-between">
                                            <a-col class="laneFromTilte">Company Name</a-col>
                                            <a-col>
                                                <a-row type="flex" justify="start">
                                                    <a-checkbox size="small" style="color: #000;" @change="toRecResidenAdrsChange">Residential Address</a-checkbox>
                                                </a-row>
                                            </a-col>
                                        </a-row>
                                        <a-input :disabled="isToFromResident" size="small" v-decorator="['deliveryName']" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row type="flex" justify="space-between">
                                    <a-col :span="11">
                                        <a-form-item class="genericFrom laneFrom" label="Destinaion">
                                            <a-input size="small" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['deliveryCountry',{ rules: [{ required: true, message: 'Required&&&Destinaion' }] }]"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="11">
                                        <a-form-item class="genericFrom laneFrom" label="City">
                                            <a-input size="small" v-decorator="['deliveryCity', { rules: [{ required: true, message: 'Required&&&City' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row  type="flex" justify="space-between">
                                    <a-col :span="7">
                                        <a-form-item class="genericFrom laneFrom" label="Postcode">
                                            <a-input size="small" v-decorator="['deliveryPostalCode']" :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="7">
                                        <a-form-item class="genericFrom laneFrom" label="Suburb">
                                            <a-input size="small" v-decorator="['deliverySuburb']" :placeholder="$t('publicLang.PleaseEnter')"/>
                                        </a-form-item>
                                    </a-col>
                                    <a-col :span="7">
                                        <a-form-item class="genericFrom laneFrom" label="State">
                                            <a-input size="small" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['deliveryProvince']"/>
                                        </a-form-item>
                                    </a-col>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="Mobile (Preferred)/Landine">
                                        <a-row type="flex" justify="start">
                                            <a-col :span="6"><a-input size="small" :placeholder="$t('publicLang.PleaseEnter')" v-decorator="['deliveryMCountryCode',{ rules: [{ required: true, message: 'Required&&&Mobile (Preferred)/Landine' }] }]" /></a-col>
                                            <a-col :span="10" class="ml4"><a-input size="small" v-decorator="['deliveryPhone']" :placeholder="$t('publicLang.PleaseEnter')"/></a-col>
                                        </a-row>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="Email">
                                        <a-input size="small" v-decorator="['deliveryEmail',{ rules: [{ required: true, message: 'From email is invalid format&&&Email' },{type: 'email',message: 'The input is not valid E-mail!'},]}]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom" label="Address">
                                        <a-input size="small" v-decorator="['deliveryAddress1', { rules: [{ required: true, message: 'Required&&&Address' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom">
                                        <a-input class="mt" size="small" v-decorator="['deliveryAddress2', { rules: [{ required: true, message: 'Required&&&Address' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                                <a-row>
                                    <a-form-item class="genericFrom laneFrom">
                                        <a-input class="mt" size="small" v-decorator="['deliveryAddress3', { rules: [{ required: true, message: 'Required&&&Address' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                    </a-form-item>
                                </a-row>
                            </a-row>
                        </a-col>
                        <a-col :span="6" style="padding-left: 8px;">
                            <a-row type="flex" justify="start" align="middle">
                                <a-col class="titleNom">3</a-col>
                                <a-col class="titleFromName ml4" :span="20">Reference</a-col>
                            </a-row>
                            <a-row>
                                <a-form-item class="genericFrom laneFrom" label="Invoice/Trans No">
                                    <a-input size="small" v-decorator="['custRef1', { rules: [{ required: true, message: 'Required&&&Invoice/Trans No' }] }]" :placeholder="$t('publicLang.PleaseEnter')"/>
                                </a-form-item>
                            </a-row>

                            <a-row type="flex" justify="start" align="middle" style="margin-top: 50px;">
                                <a-col class="titleNom">4</a-col>
                                <a-col class="titleFromName ml4" :span="20">4. Shipper’s Agreement</a-col>
                            </a-row>
                            <a-row class="mt">
                                Unless otherwise agreed in writing, I/we agree that CN Logistics' Terms and Conditions of Carriage are all the terms of the contract between me/us and CN Logistics and (1) such Terms and Conditions and, where applicable, the Warsaw Convention limits and/or excludes CN Logistics' liability for loss, damage or delay and (2) this shipment does not contain cash or dangerous goods
                            </a-row>
                            <a-row class="mt">see<span style="text-decoration:underline" @click="temsCondions"> Tems & Condions</span></a-row>
                            <a-row type="flex" justify="space-between">
                                <a-col class="mt"><a-checkbox v-model="iArgeeCheckBox">I Argee</a-checkbox></a-col>
                                <a-col class="mt">
                                    <a-form-item class="genericFrom laneFrom" >
                                        <span class="laneFromTilte">Date</span>
                                        <a-date-picker
                                                size="small"
                                                allowClear
                                                v-decorator="['orderDate',{initialValue: moment(new Date(), 'YYYY-MM-DD')}]"
                                                disabled/>
                                    </a-form-item>
                                </a-col>
                            </a-row>
                            <a-row class="mt">
                                <a-button type="primary" size="small" @click="submitFrom" :disabled="!iArgeeCheckBox" style="background: #2b386f;color: #fff;">SUBMIT</a-button>
                            </a-row>
                        </a-col>
                    </a-form>
                </a-row>
        </vxe-modal>
        <!--Tems &Condions-->
        <vxe-modal v-model="temsVis" title="Tems &Condions" width="60%" height="40%">
            <a-row class="mt">
                Unless otherwise agreed in writing, I/we agree that CN Logistics' Terms and Conditions of Carriage are all the terms of the contract between me/us and CN Logistics and (1) such Terms and Conditions and, where applicable, the Warsaw Convention limits and/or excludes CN Logistics' liability for loss, damage or delay and (2) this shipment does not contain cash or dangerous goods
            </a-row>
        </vxe-modal>
    </div>
</template>
<script>
    import moment from 'moment'
    import ajax from '../../api/ajax'
    import api from '../../api/url'
    export default{
        data(){
            return{
                vis: false,
                temsVis: false,
                isFromResident: false,
                iArgeeCheckBox: true,
                isToFromResident: false,
                form:this.$form.createForm(this)
            }
        },
        methods:{
            moment,
            show(){
                this.vis = true
                this.form.resetFields();
            },
//            from Residential change 事件
            ResidentialAdrsChange(val){
                this.isFromResident = val.target.checked
                if(this.isFromResident){
                    this.form.setFieldsValue({pickupName: null})
                }
            },
//            to rec 的Residential change 事件
            toRecResidenAdrsChange(val){
                this.isToFromResident = val.target.checked
                if(this.isToFromResident){
                    this.form.setFieldsValue({deliveryName: null})
                }
            },
            submitFrom(){
                this.form.validateFields((err, values) => {
                    if (!err) {
                        let params = values
                        params.orderDate =  values['orderDate'].format('YYYY-MM-DD')
                        ajax.post(api.TMSSHIPMENTFROM,params).then(res=>{
                            if(res.code == 200){
                                this.$message.success('Success submit')
                                this.form.resetFields();
                            }
                        })
                    }else{
                        for(let i in err){
                            let val = err[i].errors[0].message
                            this.$customMessage.warning('From'+ val.split('&&&')[1]+ ' is ' + val.split('&&&')[0])
                        }
                    }
                });
            },
            temsCondions(){
              this.temsVis = true
            }
        }
    }
</script>
<style lang="less">
    .laneFromTilte{
        font-size: 12px;
        font-weight:700;
        color: #000;
    }
    .titleNom{
        width:25px;
        background: #0d1e52;
        text-align: center;
        color: #fff;
    }
    .titleFromName{
        border: 1px solid #efefef;
        background: #fff;
    }
    .fromRce{
        border: 1px solid #efefef;
        border-top: none;
        border-bottom: none;
        padding:0 8px;
    }
   .laneFrom>.ant-form-item-label>label{
        color: #000;
    }
</style>